import React from "react";
import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { youtube } from "../data/content";
import { FiYoutube, FiPlay, FiCheck } from "react-icons/fi";

export default function YouTubeSection() {
  return (
    <section id="youtube" className="section">
      <div className="container">
        <div className="yt-grid" style={{ display: "grid", gridTemplateColumns: "0.9fr 1.1fr", gap: 56, alignItems: "center" }}>
          <Reveal>
            <motion.div
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 250, damping: 20 }}
              style={{
                position: "relative",
                borderRadius: 24,
                overflow: "hidden",
                aspectRatio: "16 / 11",
                background:
                  "radial-gradient(circle at 30% 20%, rgba(255,0,0,0.18), transparent 55%), linear-gradient(160deg, rgba(14,14,23,0.6) 0%, rgba(19,19,31,0.6) 100%)",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
                border: "1px solid var(--border-strong)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage:
                    "linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)",
                  backgroundSize: "26px 26px",
                }}
              />
              <motion.div
                aria-hidden="true"
                animate={{ scale: [1, 1.08, 1] }}
                transition={{ repeat: Infinity, duration: 2.4, ease: "easeInOut" }}
                style={{
                  width: 84,
                  height: 84,
                  borderRadius: "50%",
                  background: "#ff0033",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 0 60px rgba(255,0,51,0.5)",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <FiPlay size={30} color="#fff" style={{ marginLeft: 4 }} />
              </motion.div>
              <div style={{ position: "absolute", bottom: 20, left: 20, right: 20, display: "flex", justifyContent: "space-between", zIndex: 1 }}>
                <span className="tag" style={{ background: "rgba(0,0,0,0.4)" }}>{youtube.handle}</span>
                <span className="tag" style={{ background: "rgba(0,0,0,0.4)" }}>{youtube.subs} subs</span>
              </div>
            </motion.div>

            <Reveal delay={0.12}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, marginTop: 16 }}>
                {[
                  [youtube.subs, "Subscribers"],
                  [youtube.views, "Total Views"],
                  [youtube.watchHours, "Watch Hours"],
                ].map(([value, label]) => (
                  <div key={label} className="card" style={{ padding: "16px 12px", textAlign: "center" }}>
                    <div className="gradient-text" style={{ fontFamily: "var(--font-display)", fontSize: 22, fontWeight: 700 }}>
                      {value}
                    </div>
                    <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>{label}</div>
                  </div>
                ))}
              </div>
            </Reveal>
          </Reveal>

          <div>
            <Reveal>
              <div className="eyebrow">
                <FiYoutube style={{ marginRight: 2 }} /> YouTube
              </div>
              <h2 className="section-title">
                Teaching what I <span className="gradient-text">learn while building.</span>
              </h2>
              <p style={{ color: "var(--text-muted)", fontSize: 17, lineHeight: 1.75, marginBottom: 28 }}>
                {youtube.description}
              </p>
            </Reveal>

            <Reveal delay={0.1}>
              <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 12, marginBottom: 34 }}>
                {youtube.topics.map((t) => (
                  <li key={t} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 15, color: "var(--text-muted)" }}>
                    <span
                      style={{
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        background: "rgba(0,255,157,0.12)",
                        color: "var(--accent-3)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <FiCheck size={13} />
                    </span>
                    {t}
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={0.18}>
              <a href={youtube.url} target="_blank" rel="noreferrer" className="btn btn-primary">
                <FiYoutube size={18} /> Subscribe to {youtube.channelName}
              </a>
            </Reveal>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 860px) {
          .yt-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
